const types = {
  SHOW_LOADER: '@loader/SHOW_LOADER',
  HIDE_LOADER: '@loader/HIDE_LOADER',
};

export default types;
